import {DataFetcher} from '@aboutyou/data-fetcher';
import {
  BasketPageTitlePrice,
  BasketTitle,
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  tabletAndUp,
} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';
import {useBasketPageTitleSection} from '../hooks/useGetBasketPageSection';
import {BasketPageTitleProps, BasketPageTitleView} from './BasketPageTitleView';

export const BasketPageTitle: React.FC<
  BasketPageTitleProps & {className?: string}
> = props => {
  return (
    <>
      <TitleWrapper className={props.className}>
        <DataFetcher
          request={useBasketPageTitleSection()}
          View={BasketPageTitleView}
          Error={() => null}
          Loading={BasketTitle}
          viewProps={props}
        />
      </TitleWrapper>
    </>
  );
};

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${FONT_SIZES.px20};
  font-weight: ${FONT_WEIGHTS.bold};
  color: ${COLORS.Black};

  ${BasketPageTitlePrice} {
    font-size: ${FONT_SIZES.px20};
  }

  &,
  h2 {
    line-height: 1rem;
  }

  h2 {
    margin: 0;
    display: flex;
  }

  ${tabletAndUp(css`
    min-height: 3rem;
    margin: 1rem 0.5rem 1rem 1rem;
    padding: 0;
    justify-content: flex-start;
    font-size: ${FONT_SIZES.px32};
    margin-left: 0;

    h2 {
      line-height: 1.5;
    }
  `)}
`;
